import { gql } from '@apollo/client';

export const GET_GIFT_CARDS_QUERY = gql`
  query GiftCardsQuery($sku: String!) {
    magento2 {
      storeConfig {
        storeCode
        websiteCode
        websiteName
        baseCurrencyCode
      }
      products(filter: { sku: { eq: $sku } }) {
        items {
          uid
          __typename
          name
          sku
          image {
            url
            label
          }
          ... on Magento2_GiftCardProduct {
            allowMessage
            messageMaxLength
            allowOpenAmount
            openAmountMin
            openAmountMax
            isReturnable
            isRedeemable
            giftcardType
            giftcardAmounts {
              uid
              websiteId
              value
              attributeId
              websiteValue
            }
          }
        }
      }
    }
  }
`;
